import { Typography, useDevice } from "design_system/src";
import React, { useEffect, useState } from "react";
import { TestimonialData } from "views/AboutUs/components/Testimonials/TestimonialCard";
import TestimonialsDesktop from "views/AboutUs/components/Testimonials/TestimonialsDesktop";
import TestimonialsMobile from "views/AboutUs/components/Testimonials/TestimonialsMobile";

const testimonials: TestimonialData[] = [
  {
    name: "Cristopher Bryan Batalla",
    role: "Repartidor",
    comment: "Fácil acceso a un crédito y poder moverme más fácil por la ciudad, igual que generar ingresos extras.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_1",
    small: false,
    margin: false,
    alignEnd: false,
  },
  {
    name: "Edgar alvarado lorenzo",
    role: "Repartidor Uber",
    comment: "Gracias a Ozon pude adquirir 2 motos. Facilidad de pago, intereses bajos y una de las mejores opciones de financiamiento.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_3",
    small: true,
    margin: false,
    alignEnd: true,
  },
  {
    name: "Tavera Noé",
    role: "Empleado",
    comment: "Me arriesgué y tuve buena experiencia en Ozon. Ya tengo mi segunda moto, con pagos pequeños y accesibles.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_2",
    small: false,
    margin: false,
    alignEnd: false,
  },
  {
    name: "Mariana Tomsing",
    role: "Independiente",
    comment: "En general es buena la experiencia, trabajan para colocar la moto correctamente. Sí la recomendaría con otras personas.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_7",
    small: false,
    margin: true,
    alignEnd: false,
  },
  {
    name: "Osmar Isai Estrella Osorio",
    role: "Empleado",
    comment: "Demasiado buena, la verdad lo recomiendo para gente que no tiene crédito en otras agencias, fue muy fácil y rápido.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_5",
    small: true,
    margin: true,
    alignEnd: true,
  },
  {
    name: "Andrés fuentes orizaba",
    role: "Repartidor DiDiFood",
    comment: "Dio un cambio verdaderamente drástico. Ozon, una opción muy favorable, con excelentes atenciones, súper ágiles y excelente servicio.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_9",
    small: false,
    margin: true,
    alignEnd: false,
  },
];

const testimonialsMobile: TestimonialData[] = [
  {
    name: "Cristopher Bryan Batalla",
    role: "Repartidor",
    comment: "Fácil acceso a un crédito y moverme más fácil por la ciudad, igual que generar ingresos extras.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_1"
  },
  {
    name: "Tavera Noé",
    role: "Empleado",
    comment: "Tuve buena experiencia en Ozon. Ya tengo mi segunda moto, con pagos pequeños y accesibles.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_2"
  },
  {
    name: "Edgar alvarado lorenzo",
    role: "Repartidor Uber",
    comment: "Gracias a Ozon pude adquirir 2 motos. Facilidad de pago e intereses bajos, excelente opción de financiamiento.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_3"
  },
  {
    name: "Emilio Mendez Ortiz",
    role: "Empleado",
    comment: "Ozon se adaptó a mi sueldo, me dio confianza y mi vida cambió. Segunda moto con ellos.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_4"
  },
  {
    name: "Osmar Isai Estrella Osorio",
    role: "Empleado",
    comment: "Demasiado buena, lo recomiendo para gente sin crédito. Fue muy fácil y rápido.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_5"
  },
  {
    name: "Abraham Ulloa de la cruz",
    role: "Repartidor DiDiFood",
    comment: "Excelente y sí lo recomendaría.",
    imageUrl: "https://ik.imagekit.io/ozon/Sobre%20Nosotros/Testimonios/Fotos%20usuarios%20reales/usuario_moto_financiamiento_cdmx_6"
  },
];

const reactGA = {
  name: "CTA_Home_go_to_about_us_screen",
  category: "Home",
  label: "click in CTA to go to about us page",
};

const Testimonials: React.FC = () => {
  const { isTablet: isTabletDevice, isDesktop: isDesktopDevice, isLoading } = useDevice();
  const [isDesktop, setIsDesktop] = useState<boolean>();

  useEffect(() => {
    if (!isLoading) {
      setIsDesktop(isDesktopDevice && !isTabletDevice);
    }
  }, [isTabletDevice, isDesktopDevice, isLoading]);

  if (isDesktop === undefined) return <div />;

  return (
    <section>
      <div className="dso_container p_y_md">
        <Typography
          scale="heading1"
          scaleMobile="heading3"
          weight="600"
          component="h2"
        >
          Historias que inspiran
        </Typography>
      </div>
      {!isDesktop && (
        <TestimonialsMobile
          testimonials={testimonialsMobile}
          showSeeMorCard
          reactGA={reactGA}
        />
      )}
      {isDesktop && (
        <TestimonialsDesktop
          testimonials={testimonials}
          showSeeMorCard
          reactGA={reactGA}
        />
      )}
    </section>
  );
};

export default Testimonials;
